module.exports = "https://static.energy5.com/_next/static/images/e3-66866462e46d53b0d4ccd3e319082d8b.png";